if (!customElements.get('sticky-atc-bar-minimalist')) {
  customElements.define(
    'sticky-atc-bar-minimalist',
    class StickyAtcBarMinimalist extends HTMLElement {
      constructor() {
        super();

        this.classes = {
          isOpen: 'sticky-atc-bar--show',
        };

        this.submitEl.addEventListener('click', this.onClick.bind(this));
      }

      get submitEl() {
        return (this._submitEl = this._submitEl || this.querySelector('[type="submit"]'));
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');

        this.setPurchaseButtonText();
        this.init();

        this.cartErrorUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartError, () => {
          this.resetButtonLoading();
          this.scrollToTop(this.productFormActions);
        });

        this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => {
          this.resetButtonLoading();
        });
      }

      disconnectedCallback() {
        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }

        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      init() {
        if (!this.productFormActions) {
          this.classList.remove(this.classes.isOpen);
          return;
        }

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const isAboveViewport = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.classList.toggle(this.classes.isOpen, isAboveViewport);
            });
          },
          { threshold: 1, rootMargin }
        );
        this.observer.observe(this.productFormActions);
        this.syncWithMainProductForm();
      }

      onClick() {
        this.submitEl.setAttribute('aria-disabled', 'true');
        this.submitEl.classList.add('btn--loading');
      }

      resetButtonLoading() {
        this.submitEl.removeAttribute('aria-disabled');
        this.submitEl.classList.remove('btn--loading');
      }

      scrollToTop(target, offset = 200) {
        const scrollIntoView = (selector, offset) => {
          window.scrollTo({
            behavior: 'smooth',
            top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
          });
        };

        scrollIntoView(target, offset);
      }

      setPurchaseButtonText() {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton || addButton.disabled) return;

        const addButtonText = addButton.querySelector('.btn__text');
        if (addButtonText) addButtonText.textContent = 'Kjøp nå';
      }

      updateButton(disable = true, text, modifyClass = true) {
        const addButton = this.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = 'Kjøp nå';
        }
      }

      updatePrice(variant) {
        const priceContainer = this.querySelector('.sg-sticky-price');
        if (!priceContainer || !variant) return;

        const automaticDiscountPercent = Number(priceContainer.dataset.discountPercent || 0);
        let regularPrice = Number(variant.price || 0);
        let salePrice = regularPrice;
        let discountPercent = 0;

        if (variant.compare_at_price && Number(variant.compare_at_price) > regularPrice) {
          regularPrice = Number(variant.compare_at_price);
          salePrice = Number(variant.price);
          discountPercent = Math.round(((regularPrice - salePrice) * 100) / regularPrice);
        } else if (automaticDiscountPercent > 0) {
          discountPercent = Math.round(automaticDiscountPercent);
          salePrice = Math.round((regularPrice * (100 - discountPercent)) / 100);
        }

        const isOnSale = discountPercent > 0 && regularPrice > salePrice;
        const regularRounded = Math.ceil(regularPrice / 100);
        const saleRounded = Math.ceil(salePrice / 100);

        priceContainer.classList.toggle('sg-sticky-price--sale', isOnSale);
        priceContainer.innerHTML = isOnSale
          ? `<span class="sg-sticky-price__sale">${saleRounded} kr</span><s class="sg-sticky-price__regular">${regularRounded} kr</s><span class="sg-sticky-price__badge" aria-label="minus ${discountPercent} prosent rabatt">−${discountPercent}%</span>`
          : `<span class="sg-sticky-price__normal">${regularRounded} kr</span>`;
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          this.updatePrice(variant);
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
